import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import DeleteUpliftIndexRatesMutation from '@/graphql/contracts/deleteUpliftIndexRates.mutation.gql';
import GetUpliftIndexesQuery from '@/graphql/contracts/getUpliftIndexes.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { GetUpliftIndexesVariables } from '@/graphql/contracts/_generated_/getUpliftIndexes.query';
import {
  DeleteUpliftIndexRates,
  DeleteUpliftIndexRatesVariables
} from '@/graphql/contracts/_generated_/deleteUpliftIndexRates.mutation';

export const useDeleteUpliftIndexRates = (refetchVars: GetUpliftIndexesVariables) => {
  return useMutation<DeleteUpliftIndexRates, DeleteUpliftIndexRatesVariables>(DeleteUpliftIndexRatesMutation, {
    client: apolloClientContracts,
    refetchQueries: [{
      query: GetUpliftIndexesQuery,
      variables: refetchVars,
    }],
    onError: (err) => notificationService.open({ title: 'Error', text: err.message, type: 'danger' }),
  });
};
